import React from 'react';
import { gaSendEvent } from '@/models/gaEvent';
import api from '@/services/api';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useCallback, useEffect, useState } from 'react';
import SearchInput from '../SearchInput';
import { Wrapper } from './styles';
import NewsLetter from './NewsLetter';

interface SideNavProps {
  category?: number;
  search?: string | string[];
}

const SideNav: React.FC<SideNavProps> = ({ category, search }) => {
  const router = useRouter();
  const [loading, setLoading] = useState<boolean>(false);
  const [_, setSearch] = useState<string>('');
  const [categories, setCategories] = useState([]);
  const [relatedPosts, setRelatedPosts] = useState([]);
  const [openNewsletter, setOpenNewsletter] = useState(false);

  useEffect(() => {
    const getCategories = async () => {
      try {
        const { data } = await api.get('/categories');

        setCategories(data);
      } catch (error) {
        console.log(error);
      }
    };

    const getRelatedPosts = async () => {
      try {
        const { data } = await api.get('/posts', {
          params: {
            per_page: 3,
            categories: category
          }
        });

        setRelatedPosts(data);
      } catch (error) {
        console.log(error);
      }
    };

    getCategories();
    if (category) getRelatedPosts();
  }, [category]);

  const getPostsBySearch = useCallback(async (_search) => {
    setSearch(_search);

    try {
      setLoading(true);

      const { data } = await api.get('/posts', {
        params: {
          search: _search,
          _embed: 1,
          per_page: 10
        }
      });

      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  }, []);

  return (
    <Wrapper fixed={!!category} id="sidenavWrapper">
      {openNewsletter && <NewsLetter setShow={setOpenNewsletter} />}
      <SearchInput
        value={search}
        callback={(s) => {
          router.push(`/br/blog/?search=${s}`);
        }}
        loading={loading}
      />
      <p>Categorias</p>
      {categories.map((_category) => (
        <Link key={_category.slug} href={`/blog/categoria/${_category.slug}`}>
          <a
            onClick={() =>
              gaSendEvent('Link', `${_category.name}`, 'Menu Categorias')
            }
          >
            {_category.name}
          </a>
        </Link>
      ))}
      <button
        className="newsletter"
        onClick={() => setOpenNewsletter(!openNewsletter)}
      >
        <Image src="/email.png" width={23} height={15.33} alt="Email" />
        <span>Newsletter</span>
      </button>
      {category && !!relatedPosts.length && (
        <>
          <p
            style={{
              margin: '24px 0 0 0'
            }}
          >
            Posts Relacionados
          </p>
          {relatedPosts.map((_post) => (
            <Link key={_post.slug} href={`/blog/${_post.slug}`}>
              <a className="post">{_post.title.rendered}</a>
            </Link>
          ))}
        </>
      )}
    </Wrapper>
  );
};

export default SideNav;
